<script>
import vue2Dropzone from "vue2-dropzone";
import Multiselect from "vue-multiselect";
import PageHeader from "../../components/page-header";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import {
  promoCodeService,
  productService,
  deliveryZoneService,
} from "../../services";
import {
  error_message,
  success_message,
  get_currency,
  validate_decimal_input
} from "../../Helper/helper";
import DropzonePopup from "../../components/widgets/dropzone-popup";

import { required, requiredIf, helpers } from "vuelidate/lib/validators";
import { routes } from "../../config/api_routes";
const floating = helpers.regex("floating", /^(?:\d*\.\d{1,2}|\d+)$/);

export default {
  components: {
    vueDropzone: vue2Dropzone,
    Multiselect,
    PageHeader,
    DatePicker,
    promoCodeService,
    productService,
    DropzonePopup,
  },
  data() {
    return {
      currency: get_currency(),
      tmpCouponImage: "",
      search: "",
      search1: "",
      isLoading: false,
      showTimeRangePanel: false,
      isLoading1: false,
      customer: [],
      subCategories: [],
      products: [],
      checkOpen: true,
      discount_type: "0",
      rangeSeparator: "-",
      datetime: null,
      format: "YYYY/MM/DD HH:s",
      coupon_customer: [],
      resturant: [],
      coupon_sub_category: [],
      coupon_product: [],
      updateValues: "",
      countries: [],
      categories: [],
      searchCategories: [],
      states: [],
      cities: [],
      get_sub_category: [],
      get_customer: [],
      country_count: "",
      state_count: "",
      city_count: "",
      coupon_permanent: "",
      coupon_applied_type: "",
      typeform: {
        coupon_name: "",
        coupon_code: "",
        coupon_name_other_lang: "",
        description_other_lang: "",
        minimum_order_amount: "",
        country: "",
        orders_valid_for_first: "",
        state: "",
        city: "",
        checkbox: false,
        customercheckbox: false,
        coupon_type: "",
        image: "",
        coupon_sub_category: "",
        coupon_customer: "",
        coupon_product: "",
        is_show_customer_app: "",
        discount_percentage: "",
        maximum_discount_amount: "",
        is_flat_discount: "",
        per_user_usage: "",
        minimum_order_amount: "",
        description: "",
        max_user_count: "",
        flat_discount: "",
        datetime: "",
        get_sub_category: "",
        get_customer: "",
        status: "",
        show_display_text: "",
        show_display_text_another_lang: "",
        is_permanent: "",
        category_id: "",
        coupon_applied_for: "",
        order_type: "",
      },
      coupon_image: "",
      coupon_image_path: "",
      coupon_image_delete_url: routes.promoCodeImageDeleteUrl,
      id: "",
      defaultcountry: "",
      defaultstate: "",
      defaultcity: "",
    };
  },
  validations: {
    typeform: {
      coupon_name: {
        required,
      },
      coupon_name_other_lang: {
        required
      },
      coupon_code: {
        required,
      },
      // category_id: {
      //   required: requiredIf(function (form) {
      //     return this.coupon_applied_type == 0;
      //   }),
      // },
      coupon_applied_for: {
        required,
      },
      minimum_order_amount: {
        required,
        floating,
      },
      image: {
        required: requiredIf(function (nestedModel) {
          return !(!!this.coupon_image || !!this.typeform.image);
        }),
      },
      datetime: {
        required: requiredIf(function (form) {
          return this.coupon_permanent == 0;
        }),
      },
      max_user_count: {
        floating,
      },
      discount_percentage: {
        required: requiredIf(function (form) {
          return this.typeform.is_flat_discount == "0";
        }),
        floating,
      },
      maximum_discount_amount: {
        required: requiredIf(function (form) {
          return this.typeform.is_flat_discount == "0";
        }),
        floating,
      },
      flat_discount: {
        required: requiredIf(function (form) {
          return this.typeform.is_flat_discount == "1";
        }),
        floating,
      },
      description: {
        required,
      },
      description_other_lang: {
        required
      },
      is_permanent: {
        required,
      },
      order_type: {
        required,
      },
      coupon_sub_category: {
        required: requiredIf(function (nestedModel) {
          return (
            this.typeform.get_sub_category == 0 && this.coupon_applied_type == 0
          );
        }),
      },
      coupon_customer: {
        required: requiredIf(function (nestedModel) {
          return this.typeform.get_customer == 0;
        }),
      },
      coupon_product: {
        required: requiredIf(function (nestedModel) {
          return (
            this.typeform.get_product == 0 && this.coupon_applied_type == 1
          );
        }),
      },
    },
  },
  mounted() {
    this.getPromoCodeById();
    this.getMainCategory();
  },
  methods: {
    nameWithLang({ customer_name }) {
      // Return the customer name directly
      return customer_name;
    },
    disabledBeforeTodayAndAfterAWeek(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
    onPromoCodeImagedeleted(value) {
      this.coupon_image = "";
    },
    toggleTimeRangePanel() {
      this.showTimeRangePanel = !this.showTimeRangePanel;
    },
    handleRangeClose() {
      this.showTimeRangePanel = false;
    },
    Onclick: function () {
      if (this.typeform.get_sub_category == 1) {
        this.typeform.get_sub_category = !this.typeform.get_sub_category;
      }
      this.typeform.coupon_sub_category = "";
    },
    customerOnclick: function () {
      if (this.typeform.get_customer == 1) {
        this.typeform.get_customer = !this.typeform.get_customer;
      }
      this.typeform.coupon_customer = "";
    },

    productOnclick: function () {
      if (this.typeform.get_product == 1) {
        this.typeform.get_product = !this.typeform.get_product;
      }
      this.typeform.get_product = "";
    },

    dateFormat(classes, date) {},

    asyncSubCategory(query) {
      this.isLoading = true;
      promoCodeService
        .getSubcategorySearch({
          search: query,
          category_id: this.typeform.category_id,
        })
        .then((response) => {
          // this.searchCategories = response.data.result;
          this.searchCategories = response.data.result.sort((a, b) => {
              return a.menu_name.localeCompare(b.menu_name);
          });
          this.isLoading = false;
        });
    },
    clearAll() {
      this.coupon_sub_category = [];
    },
    asyncFindCustomer(query) {
      this.isLoading = true;
      promoCodeService.getCustomer(query).then((response) => {
        // this.customer = response.data.result;
        this.customer = response.data.result.sort((a, b) => {
          return a.customer_name.localeCompare(b.customer_name);
        });
        this.isLoading1 = false;
      });
    },
    clearAllCustomer() {
      this.coupon_customer = [];
    },
    clearAllProduct() {
      this.coupon_product = [];
    },
    getPromoCodeById() {
      promoCodeService
        .getPromoCodeById({ id: this.$route.params.id })
        .then((response) => {
          const {
            id,
            coupon_name,
            coupon_code,
            coupon_name_other_lang,
            description,
            description_other_lang,
            minimum_order_amount,
            country,
            orders_valid_for_first,
            state,
            city,
            coupon_type,
            coupon_sub_category,
            coupon_customer,
            coupon_product,
            is_show_customer_app,
            discount_percentage,
            maximum_discount_amount,
            is_flat_discount,
            flat_discount,
            max_user_count,
            per_user_usage,
            get_sub_category,
            get_product,
            get_customer,
            status,
            show_display_text,
            show_display_text_another_lang,
            category_id,
            coupon_applied_for,
            is_permanent,
            order_type,
          } = response.data.result;
          this.coupon_image_path = response.data.result.coupon_image_path;
          this.coupon_image = response.data.result.coupon_image;
          this.id = response.data.result.id;
          this.typeform = {
            id,
            coupon_name,
            coupon_code,
            coupon_name_other_lang,
            description,
            description_other_lang,
            minimum_order_amount,
            country,
            orders_valid_for_first,
            state,
            city,
            coupon_type,
            coupon_sub_category,
            coupon_customer,
            coupon_product,
            is_show_customer_app,
            discount_percentage,
            maximum_discount_amount,
            is_flat_discount,
            flat_discount,
            max_user_count,
            per_user_usage,
            get_sub_category,
            get_product,
            get_customer,
            status,
            show_display_text,
            show_display_text_another_lang,
            category_id,
            coupon_applied_for,
            is_permanent,
            order_type,
          };
          this.typeform.datetime = response.data.result.datetime.split(" - ");
          this.typeform.get_sub_category =
            response.data.result.get_sub_category.length;
          this.typeform.get_product = response.data.result.get_product.length;
          this.typeform.get_customer = response.data.result.get_customer.length;
          this.defaultcountry = this.typeform.country;
          this.defaultstate = this.typeform.state;
          this.defaultcity = this.typeform.city;
          this.coupon_applied_type = this.typeform.coupon_applied_for;
          this.coupon_permanent = this.typeform.is_permanent;
        });
    },
    getVendorCountry() {
      this.typeform.state = "";
      this.typeform.city = "";
      this.states = [];
      this.cities = [];
      deliveryZoneService.getVendorCountry().then((response) => {
        this.country_count = response.data.result.length;
        this.countries = response.data.result;
        if (this.country_count == 1) {
          this.typeform.country = this.countries[0].id;
          this.getVendorState();
        } else if (this.country_count > 0) {
          if (this.typeform.country > 0) {
            this.getVendorState();
          }
        }
      });
    },
    getVendorState() {
      this.states = [];
      this.cities = [];
      this.city_count = 0;
      this.state_count = 0;
      this.typeform.city = "";
      this.typeform.state = "";
      if (!this.typeform.country) return false;
      deliveryZoneService
        .getVendorState({ country_id: this.typeform.country })
        .then((response) => {
          this.state_count = response.data.result.length;
          this.states = response.data.result;
          if (
            this.defaultcountry === this.typeform.country &&
            this.state_count > 0
          ) {
            this.typeform.state = this.defaultstate;
          }
          if (this.state_count == 1) {
            this.typeform.state = this.states[0].id;
            this.getVendorCity();
          } else {
            if (
              this.defaultcountry === this.typeform.country &&
              this.state_count > 0
            ) {
              if (this.typeform.state > 0) {
                this.getVendorCity();
              }
            }
          }
        });
    },
    getVendorCity() {
      this.cities = [];
      this.city_count = 0;
      if (!this.typeform.state) return false;
      deliveryZoneService
        .getVendorCity({ state_id: this.typeform.state })
        .then((response) => {
          this.city_count = response.data.result.length;
          this.cities = response.data.result;
          if (
            this.defaultcountry === this.typeform.country &&
            this.state_count > 0
          ) {
            if (
              this.defaultstate === this.typeform.state &&
              this.city_count > 0
            ) {
              this.typeform.city = this.defaultcity;
            }
          }
          if (this.city_count == 1) {
            this.typeform.city = this.cities[0].cityid;
          }
        });
    },
    getMainCategory() {
      productService.getMainCategory().then((response) => {
        this.categories = response.data.result;
      });
    },
    // getSubCategory(event) {
    //   this.typeform.category_id = event.target.value;
    // },
    onRoleChange() {
      this.coupon_permanent = this.typeform.is_permanent;
    },
    onTypeChange() {
      this.coupon_applied_type = this.typeform.coupon_applied_for;
    },
    onOrderTypeChange() {
      this.order_type = this.typeform.order_type;
    },
    couponInIt() {
      this.$v.$touch();
      if (this.$v.typeform.$invalid) {
        setTimeout(()=>{
            $('html, body').animate({
                scrollTop: $(".is-invalid:first").offset().top-$('#page-topbar').height()-50
            }, 500, function() {
                $(".is-invalid:first").focus();
            });
        },500);
        return;
      } else {
        const fd = new FormData();
        fd.append("id", this.typeform.id);
        fd.append("coupon_name", this.typeform.coupon_name);
        fd.append(
          "coupon_name_other_lang",
          this.typeform.coupon_name_other_lang
        );
        fd.append("description", this.typeform.description);
        fd.append(
          "description_other_lang",
          this.typeform.description_other_lang
        );
        fd.append("order_type", this.typeform.order_type);
        fd.append("coupon_code", this.typeform.coupon_code);
        if (!!this.typeform.image) {
          fd.append("coupon_image", this.typeform.image);
        }
        fd.append("coupon_type", this.typeform.coupon_type);
        fd.append("is_show_customer_app", this.typeform.is_show_customer_app);
        fd.append("is_flat_discount", this.typeform.is_flat_discount ? 1 : 0);
        fd.append("flat_discount", this.typeform.flat_discount);
        fd.append("discount_percentage", this.typeform.discount_percentage);
        fd.append(
          "maximum_discount_amount",
          this.typeform.maximum_discount_amount
        );
        fd.append("minimum_order_amount", this.typeform.minimum_order_amount);
        fd.append("per_user_usage", this.typeform.per_user_usage);
        fd.append("max_user_count", this.typeform.max_user_count);
        fd.append(
          "orders_valid_for_first",
          this.typeform.orders_valid_for_first
        );
        fd.append("country", this.typeform.country);
        fd.append("state", this.typeform.state);
        fd.append("city", this.typeform.city);
        fd.append("datetime", this.typeform.datetime);
        fd.append("status", this.typeform.status);
        fd.append("show_display_text", this.typeform.show_display_text);
        fd.append(
          "show_display_text_another_lang",
          this.typeform.show_display_text_another_lang
        );
        fd.append("is_permanent", this.typeform.is_permanent);
        fd.append("coupon_applied_for", this.typeform.coupon_applied_for);
        fd.append("category_id", this.typeform.category_id);
        if (
          this.typeform.get_sub_category == 1 &&
          this.coupon_applied_type == 0
        ) {
          fd.append("get_sub_category", 0);
        } else {
          this.typeform.coupon_sub_category
            .map((item) => item.id)
            .map((item, index) => {
              fd.append("coupon_sub_category[" + index + "]", item);
            });
        }

        if (this.typeform.get_product == 1 && this.coupon_applied_type == 1) {
          fd.append("get_product", 0);
        } else {
          this.typeform.coupon_product
            .map((item) => item.id)
            .map((item, index) => {
              fd.append("coupon_product[" + index + "]", item);
            });
        }

        if (this.typeform.get_customer == 1) {
          fd.append("get_customer", 0);
        } else {
          this.typeform.coupon_customer
            .map((item) => item.user_id)
            .map((item, index) => {
              fd.append("coupon_customer[" + index + "]", item);
            });
        }
        promoCodeService.updatePromoCodeById(fd).then((response) => {
          if (response.data.code === 200) {
            success_message(response.data.message);
            this.$router.push({ name: "coupon-list" });
          } else {
            error_message(response.data.message);
          }
        });
      }
    },
    asyncProduct(query) {
      this.isLoading = true;
      promoCodeService.getProductSearch({ search: query }).then((response) => {
        // this.products = response.data.result;
        this.products = response.data.result.sort((a, b) => {
            return a.item_name.localeCompare(b.item_name);
        });
        this.isLoading = false;
      });
    },
    validateMinPrice(value){
      this.typeform.minimum_order_amount = validate_decimal_input(value);
    },
    validateMaxPrice(value){
      this.typeform.maximum_discount_amount = validate_decimal_input(value);
    },
    validateFlatDiscount(value){
      this.typeform.flat_discount = validate_decimal_input(value);
    },
    validateDiscountPercent(value){
      this.typeform.discount_percentage = validate_decimal_input(value);
    }
  },
  
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div
          class="
            page-title-box
            d-flex
            align-items-center
            justify-content-between
            icon-main-page
          "
        >
          <div class="page-title-left avatar-main-icon">
            <div class="avatar-xs mr-3">
              <span
                class="
                  avatar-title
                  rounded-circle
                  bg-soft-primary
                  text-primary
                  font-size-18
                "
              >
                <i class="bx bx-purchase-tag"></i>
              </span>
            </div>
            <div class="report-tag">
              <h4 class="mb-0 font-size-18">{{ this.typeform.coupon_name }}</h4>
              <p>
                <router-link :to="{ name: 'coupon-list' }">{{
                  trans.get("__JSON__.PROMO CODES")
                }}</router-link>
                > {{ this.typeform.coupon_name }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <form action="#" @submit.prevent="couponInIt">
          <input type="hidden" name="id" v-model="typeform.id" />
          <!-- Promo Code Detail Section Start -->
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">
                {{ trans.get("__JSON__.Promo Code Detail") }}
              </h4>
              <p class="card-title-desc"></p>
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="control-label required">{{
                      trans.trans("__JSON__.Promo Code Name Language", {
                        lang: $auth.langauges[0].name,
                      })
                    }}</label>
                    <input
                      id="coupon_name"
                      v-model="$v.typeform.coupon_name.$model"
                      type="text"
                      class="form-control"
                      :placeholder="
                        trans.trans('__JSON__.Promo Code Name Language', {
                          lang: $auth.langauges[0].name,
                        })
                      "
                      name="coupon_name"
                      :class="{ 'is-invalid': $v.typeform.coupon_name.$error }"
                    />
                    <div
                      v-if="$v.typeform.coupon_name.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.typeform.coupon_name.required"
                        >{{
                          trans.get("__JSON__.Please enter promo code name")
                        }}.</span
                      >
                    </div>
                  </div>
                </div>

                <div
                  class="col-sm-6 d-none"
                  v-if="$auth.langauges[1].name === 'No Secondary Language'"
                ></div>
                <div class="col-sm-6" v-else>
                  <div class="form-group">
                    <label class="control-label required">{{
                      trans.trans(
                        "__JSON__.Promo Code Name Secondary Language(Optional)",
                        { lang: $auth.langauges[1].name }
                      )
                    }}</label>
                    <input
                      maxlength="100"
                      id="coupon_name_other_lang"
                      name="coupon_name_other_lang"
                      v-model="typeform.coupon_name_other_lang"
                      type="text"
                      :placeholder="
                        trans.trans(
                          '__JSON__.Promo Code Name Secondary Language(Optional)',
                          { lang: $auth.langauges[1].name }
                        )
                      "
                      class="form-control"
                      :class="{ 'is-invalid': $v.typeform.coupon_name_other_lang.$error }"
                    />
                    <div
                      v-if="$v.typeform.coupon_name_other_lang.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.typeform.coupon_name_other_lang.required"
                        >{{
                          trans.get("__JSON__.Please enter promo code name")
                        }}.</span
                      >
                    </div>
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="control-label required">{{
                      trans.get("__JSON__.Promo Code")
                    }}</label>
                    <input
                      maxlength="15"
                      minlength="1"
                      id="coupon_code"
                      disabled
                      v-model="$v.typeform.coupon_code.$model"
                      type="text"
                      class="form-control"
                      :placeholder="this.trans.get('__JSON__.Enter Promo Code')"
                      name="coupon_code"
                      :class="{ 'is-invalid': $v.typeform.coupon_code.$error }"
                    />
                    <div
                      v-if="$v.typeform.coupon_code.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.typeform.coupon_code.required"
                        >{{
                          trans.get("__JSON__.Please enter promo code")
                        }}.</span
                      >
                    </div>
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="control-label required">{{
                      trans.trans(
                        "__JSON__.Promo Code Description Primary Language",
                        { lang: $auth.langauges[0].name }
                      )
                    }}</label>
                    <textarea
                      rows="5"
                      id="description"
                      v-model="$v.typeform.description.$model"
                      type="text"
                      class="form-control"
                      :placeholder="
                        trans.trans(
                          '__JSON__.Promo Code Description Primary Language',
                          { lang: $auth.langauges[0].name }
                        )
                      "
                      name="description"
                      :class="{ 'is-invalid': $v.typeform.description.$error }"
                    ></textarea>
                    <div
                      v-if="$v.typeform.description.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.typeform.description.required"
                        >{{
                          trans.get(
                            "__JSON__.Please enter promo code description"
                          )
                        }}.</span
                      >
                    </div>
                  </div>
                </div>

                <div
                  class="col-sm-6 d-none"
                  v-if="$auth.langauges[1].name === 'No Secondary Language'"
                ></div>
                <div class="col-sm-6" v-else>
                  <div class="form-group">
                    <label class="control-label required">{{
                      trans.trans(
                        "__JSON__.Promo Code Description Secondary Language(Optional)",
                        { lang: $auth.langauges[1].name }
                      )
                    }}</label>
                    <textarea
                      rows="5"
                      id="description_other_lang"
                      v-model="$v.typeform.description_other_lang.$model"
                      type="text"
                      class="form-control"
                      :placeholder="
                        trans.trans(
                          '__JSON__.Promo Code Description Secondary Language(Optional)',
                          { lang: $auth.langauges[1].name }
                        )
                      "
                      name="description_other_lang"
                      :class="{ 'is-invalid': $v.typeform.description_other_lang.$error }"
                    ></textarea>
                    <div
                      v-if="$v.typeform.description_other_lang.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.typeform.description_other_lang.required"
                        >{{
                          trans.get(
                            "__JSON__.Please enter promo code description"
                          )
                        }}.</span
                      >
                    </div>
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="control-label">{{
                      trans.trans("__JSON__.Display Text Primary Language", {
                        lang: $auth.langauges[0].name,
                      })
                    }}</label>
                    <textarea
                      rows="5"
                      id="show_display_text"
                      v-model="typeform.show_display_text"
                      type="text"
                      class="form-control"
                      :placeholder="
                        trans.trans('__JSON__.Display Text Primary Language', {
                          lang: $auth.langauges[0].name,
                        })
                      "
                      name="description"
                    ></textarea>
                  </div>
                </div>

                <div
                  class="col-sm-6 d-none"
                  v-if="$auth.langauges[1].name === 'No Secondary Language'"
                ></div>
                <div class="col-sm-6" v-else>
                  <div class="form-group">
                    <label class="control-label">{{
                      trans.trans(
                        "__JSON__.Display Text Secondary Language(Optional)",
                        { lang: $auth.langauges[1].name }
                      )
                    }}</label>
                    <textarea
                      rows="5"
                      id="show_display_text_another_lang"
                      v-model="typeform.show_display_text_another_lang"
                      type="text"
                      class="form-control"
                      :placeholder="
                        trans.trans(
                          '__JSON__.Display Text Secondary Language(Optional)',
                          { lang: $auth.langauges[1].name }
                        )
                      "
                      name="show_display_text_another_lang"
                    ></textarea>
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="control-label required">{{
                      trans.get("__JSON__.Promo Code Image")
                    }}</label>
                    <dropzone-popup
                      v-model="typeform.image"
                      type="file"
                      id="coupon_image"
                      name="coupon_image"
                      acceptedFiles=".jpeg,.jpg,.png"
                      :editable-images="coupon_image"
                      :media-path="coupon_image_path + '/original'"
                      :delete-path="coupon_image_delete_url"
                      @image-deleted="this.onPromoCodeImagedeleted"
                      :class="{ 'is-invalid': $v.typeform.image.$error }"
                    />
                    <div
                      v-if="$v.typeform.image.$error"
                      class="invalid-feedback cuisine-img"
                    >
                      <span v-if="!$v.typeform.image.required"
                        >{{
                          trans.get("__JSON__.Please select promo code Image")
                        }}.</span
                      >
                    </div>
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="control-label required">{{
                      trans.get("__JSON__.Discount Applied For")
                    }}</label>
                    <select
                      class="custom-select"
                      v-model="$v.typeform.coupon_applied_for.$model"
                      id="coupon_applied_for"
                      name="coupon_applied_for"
                      :class="{
                        'is-invalid': $v.typeform.coupon_applied_for.$error,
                      }"
                      @change="onTypeChange()"
                    >
                      <option value="">
                        {{ trans.get("__JSON__.Select Type") }}
                      </option>
                      <option value="1">
                        {{ trans.get("__JSON__.Product") }}
                      </option>
                      <option value="0">
                        {{ trans.get("__JSON__.Sub Category") }}
                      </option>
                      
                    </select>
                    <div
                      v-if="$v.typeform.coupon_applied_for.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.typeform.coupon_applied_for.required">{{
                        trans.get("__JSON__.Please select type")
                      }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="control-label required">{{
                      trans.get("__JSON__.Is Permanent Promo Code")
                    }}</label>
                    <select
                      name="is_permanent"
                      class="custom-select"
                      id="is_permanent"
                      v-model="$v.typeform.is_permanent.$model"
                      :class="{ 'is-invalid': $v.typeform.is_permanent.$error }"
                      @change="onRoleChange()"
                    >
                      <option value="">
                        {{ trans.get("__JSON__.Select Promo Code Type") }}
                      </option>
                      <option value="1" selected>
                        {{ trans.get("__JSON__.Yes") }}
                      </option>
                      <option value="0">{{ trans.get("__JSON__.No") }}</option>
                    </select>
                    <div
                      v-if="$v.typeform.is_permanent.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.typeform.is_permanent.required">{{
                        trans.get("__JSON__.Please select promo code type")
                      }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="control-label required">{{
                      trans.get("__JSON__.Discount Valid For (order_type)")
                    }}</label>
                    <select
                      name="order_type"
                      class="custom-select"
                      id="order_type"
                      v-model="$v.typeform.order_type.$model"
                      :class="{ 'is-invalid': $v.typeform.order_type.$error }"
                      @change="onOrderTypeChange()"
                    >
                      <option value="">
                        {{ trans.get("__JSON__.Select Promo Code Type") }}
                      </option>
                      <option value="0">
                        {{ trans.get("__JSON__.Both") }}
                      </option>
                      <option value="1">
                        {{ trans.get("__JSON__.Normal") }}
                      </option>
                      <option value="2">
                        {{ trans.get("__JSON__.Subscription") }}
                      </option>
                    </select>
                    <div
                      v-if="$v.typeform.order_type.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.typeform.order_type.required">{{
                        trans.get("__JSON__.Please select promo code type")
                      }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-6" v-if="this.coupon_permanent != 1">
                  <div class="form-group">
                    <label class="control-label">{{
                      trans.get("__JSON__.Promo Code Redeem start/end Period")
                    }}</label>
                    <br />
                    <date-picker
                      name="datetime"
                      id="datetime"
                      v-model="$v.typeform.datetime.$model"
                      :disabled-date="disabledBeforeTodayAndAfterAWeek"
                      type="datetime"
                      value-type="format"
                      range
                      :show-time-panel="showTimeRangePanel"
                      @close="handleRangeClose"
                      :class="{ 'is-invalid': $v.typeform.datetime.$error }"
                    >
                      <template v-slot:footer>
                        <button
                          class="mx-btn mx-btn-text"
                          @click="toggleTimeRangePanel"
                        >
                          {{
                            showTimeRangePanel ? "select date" : "select time"
                          }}
                        </button>
                      </template>
                    </date-picker>
                    <div
                      v-if="$v.typeform.datetime.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.typeform.datetime.required"
                        >{{ trans.get("__JSON__.Please select date") }}.</span
                      >
                    </div>
                  </div>
                </div>

                <div class="col-sm-6 vendor-status">
                  <b-form-group
                    id="input-group-1"
                    :label="trans.get('__JSON__.Status')"
                    label-for="status"
                  >
                    <label class="switch">
                      <input
                        type="checkbox"
                        id="togBtn"
                        name="status"
                        v-model="typeform.status"
                        class="switch-on"
                        true-value="1"
                        false-value="0"
                      />
                      <div class="slider round">
                        <span class="on">{{
                          trans.get("__JSON__.Active")
                        }}</span>
                        <span class="off">{{
                          trans.get("__JSON__.Inactive")
                        }}</span>
                      </div>
                    </label>
                  </b-form-group>
                </div>
              </div>
            </div>
          </div>
          <!-- Promo Code Detail Section End -->

          <!-- Discount Details Section Start -->
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">
                {{ trans.get("__JSON__.Discount Details") }}
              </h4>
              <p class="card-title-desc"></p>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label class="control-label">{{
                        trans.get("__JSON__.Coupon Valid For")
                      }}</label>
                      <select
                        class="custom-select"
                        v-bind:value="typeform.coupon_type"
                        v-model="typeform.coupon_type"
                        id="coupon_type"
                        name="coupon_type"
                      >
                        <option value="">
                          {{ trans.get("__JSON__.Select Coupon Type") }}
                        </option>
                        <option value="Both">
                          {{ trans.get("__JSON__.Both") }}
                        </option>
                        <option value="Delivery">
                          {{ trans.get("__JSON__.Delivery") }}
                        </option>
                        <option value="Pickup">
                          {{ trans.get("__JSON__.Pickup") }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label class="control-label">{{
                        trans.get("__JSON__.Promo Code Redeem Count")
                      }}</label>
                      <select
                        class="custom-select"
                        v-bind:value="typeform.per_user_usage"
                        v-model="typeform.per_user_usage"
                        id="per_user_usage"
                        name="per_user_usage"
                      >
                        <!-- <option value="">{{ trans.get('__JSON__.Select Redeem Count') }}</option> -->
                        <option v-bind:value="1">1</option>
                        <option v-bind:value="2">2</option>
                        <option v-bind:value="3">3</option>
                        <option v-bind:value="4">4</option>
                        <option v-bind:value="5">5</option>
                        <option v-bind:value="6">6</option>
                        <option v-bind:value="7">7</option>
                        <option v-bind:value="8">8</option>
                        <option v-bind:value="9">9</option>
                        <option v-bind:value="10">10</option>
                        <option value="Unlimited">Unlimited</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label class="control-label">{{
                        trans.get("__JSON__.Coupon Valid For First X Order")
                      }}</label>
                      <select
                        class="custom-select"
                        v-bind:value="typeform.orders_valid_for_first"
                        v-model="typeform.orders_valid_for_first"
                        id="orders_valid_for_first"
                        name="orders_valid_for_first"
                      >
                        <option :value="-1">
                          {{ trans.get("__JSON__.Unlimited") }}
                        </option>
                        <option v-bind:value="1">1</option>
                        <option v-bind:value="2">2</option>
                        <option v-bind:value="3">3</option>
                        <option v-bind:value="4">4</option>
                        <option v-bind:value="5">5</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label class="control-label">{{
                        trans.get("__JSON__.Discount Type")
                      }}</label>
                      <select
                        class="custom-select"
                        v-bind:value="typeform.is_flat_discount"
                        v-model="typeform.is_flat_discount"
                        id="discount_type"
                        name="discount_type"
                      >
                        <!-- <option value>{{ trans.get('__JSON__.Select Discount Type') }}</option> -->
                        <option v-bind:value="0">
                          {{ trans.get("__JSON__.Percentage") }}
                        </option>
                        <option v-bind:value="1">
                          {{ trans.get("__JSON__.Flat") }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-4" v-if="typeform.is_flat_discount == 0">
                    <div class="form-group">
                      <label class="control-label required"
                        >{{ trans.get("__JSON__.Discount") }} (%)</label
                      >
                      <input
                        id="discount_percentage"
                        name="discount_percentage"
                        v-model="$v.typeform.discount_percentage.$model"
                        type="text"
                        :placeholder="
                          this.trans.get(
                            '__JSON__.Enter Discount in Percentage'
                          )
                        "
                        class="form-control"
                        :class="{
                          'is-invalid': $v.typeform.discount_percentage.$error,
                        }"
                        @input="validateDiscountPercent(typeform.discount_percentage)"
                      />
                      <div
                        v-if="$v.typeform.discount_percentage.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.typeform.discount_percentage.required"
                          >{{
                            trans.get("__JSON__.Please enter discount")
                          }}.</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-4" v-if="typeform.is_flat_discount == 1">
                    <div class="form-group">
                      <label class="control-label required">
                        {{ trans.get("__JSON__.Flat Discount") }} (
                        <span v-html="currency"></span>)
                      </label>
                      <input
                        id="flat_discount"
                        name="flat_discount"
                        v-model="$v.typeform.flat_discount.$model"
                        type="text"
                        :placeholder="
                          this.trans.get(
                            '__JSON__.Enter Flat Discount in Amount'
                          )
                        "
                        class="form-control"
                        :class="{
                          'is-invalid': $v.typeform.flat_discount.$error,
                        }"
                        @input="validateFlatDiscount(typeform.flat_discount)"
                      />
                      <div
                        v-if="$v.typeform.flat_discount.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.typeform.flat_discount.required"
                          >{{
                            trans.get("__JSON__.Please enter flat discount")
                          }}.</span
                        >
                        
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-4" v-if="typeform.is_flat_discount == 0">
                    <div class="form-group">
                      <label class="control-label required">
                        {{ trans.get("__JSON__.Maximum Discount Amount") }}(
                        <span v-html="currency"></span>)
                      </label>
                      <input
                        id="maximum_discount_amount"
                        name="maximum_discount_amount"
                        type="text"
                        v-model="$v.typeform.maximum_discount_amount.$model"
                        :placeholder="
                          this.trans.get(
                            '__JSON__.Enter Maximum Discount Amount'
                          )
                        "
                        class="form-control"
                        :class="{
                          'is-invalid':
                            $v.typeform.maximum_discount_amount.$error,
                        }"
                        @input="validateMaxPrice(typeform.maximum_discount_amount)"
                      />
                      <div
                        v-if="$v.typeform.maximum_discount_amount.$error"
                        class="invalid-feedback"
                      >
                        <span
                          v-if="!$v.typeform.maximum_discount_amount.required"
                          >{{
                            trans.get("__JSON__.Please enter maximum discount")
                          }}.</span
                        >
                        
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label class="control-label required">
                        {{ trans.get("__JSON__.Minimum Order Values") }}(
                        <span v-html="currency"></span>)
                      </label>
                      <input
                        id="minimum_order_amount"
                        name="minimum_order_amount"
                        v-model="$v.typeform.minimum_order_amount.$model"
                        type="text"
                        :placeholder="
                          this.trans.get('Enter Minimum Order Amount')
                        "
                        class="form-control"
                        :class="{
                          'is-invalid': $v.typeform.minimum_order_amount.$error,
                        }"
                        @input="validateMinPrice(typeform.minimum_order_amount)"
                      />
                      <div
                        v-if="$v.typeform.minimum_order_amount.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.typeform.minimum_order_amount.required"
                          >{{
                            trans.get(
                              "__JSON__.Please enter minimum order amount"
                            )
                          }}.</span
                        >
                        
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label class="control-label">{{
                        trans.get("__JSON__.Coupon Valid For First X User")
                      }}</label>
                      <input
                        maxlength="3"
                        minlength="1"
                        id="max_user_count"
                        name="max_user_count"
                        v-model="$v.typeform.max_user_count.$model"
                        type="text"
                        :placeholder="
                          this.trans.get('Enter Max Count (FIrst X User)')
                        "
                        class="form-control"
                        :class="{
                          'is-invalid': $v.typeform.max_user_count.$error,
                        }"
                      />
                      <div
                        v-if="$v.typeform.max_user_count.$error"
                        class="invalid-feedback"
                      >
                        <!-- <span
                          v-if="!$v.typeform.max_user_count.required"
                        >{{ trans.get('__JSON__.Please enter max count number')}}.</span> -->
                        <span v-if="!$v.typeform.max_user_count.floating"
                          >{{
                            trans.get("__JSON__.This value should be digits")
                          }}.</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label
                        >{{
                          trans.get("__JSON__.Show in Customer App")
                        }}?</label
                      >
                      <div class>
                        <div class="swtich-data">
                          <label class="switch">
                            <input
                              type="checkbox"
                              id="togBtn"
                              class="switch-on"
                              true-value="1"
                              false-value="0"
                              v-model="typeform.is_show_customer_app"
                            />
                            <div class="slider round">
                              <!--ADDED HTML -->
                              <span class="on">{{
                                trans.get("__JSON__.On")
                              }}</span>
                              <span class="off">{{
                                trans.get("__JSON__.Off")
                              }}</span>
                              <!--END-->
                            </div>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Discount Details Section End -->

          <!-- Customer Section Start -->
          <div class="card">
            <div class="card-body">
              <h4 class="card-title required">{{ trans.get("__JSON__.Customers") }}</h4>
              <p class="card-title-desc"></p>
              <div class="row">
                <div class="col-md-12">
                  <div class="vendor-main">
                    <div class="col-sm-3 col-12">
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          v-on:click="customerOnclick()"
                          v-model="typeform.get_customer"
                          class="custom-control-input"
                          id="all_cust"
                          true-value="1"
                          false-value="0"
                        />
                        <label class="custom-control-label" for="all_cust">{{
                          trans.get(
                            "__JSON__.Promo code valid for all Customers"
                          )
                        }}</label>
                      </div>
                    </div>
                    <div class="col-sm-1 col-12 m-coupon-or">
                      <p>{{ trans.get("__JSON__.OR") }}</p>
                    </div>
                    <div class="col-sm-8 col-12">
                      <div class="search-box mr-2 d-inline-block">
                        <div class="position-relative">
                          <multiselect
                            v-model="$v.typeform.coupon_customer.$model"
                            id="ajax"
                            label="customer_name"
                            v-bind:disabled="typeform.get_customer == 1"
                            track-by="customer_name"
                            :custom-label="nameWithLang"
                            :placeholder="trans.get('__JSON__.Customer Search')"
                            open-direction="bottom"
                            :options="customer"
                            :multiple="true"
                            :searchable="true"
                            :loading="isLoading1"
                            :internal-search="true"
                            :clear-on-select="true"
                            :close-on-select="false"
                            :max-height="600"
                            :show-no-results="false"
                            :hide-selected="true"
                            @search-change="asyncFindCustomer"
                            :class="{
                              'is-invalid': $v.typeform.coupon_customer.$error,
                            }"
                          >
                            <template
                              slot="tag"
                              slot-scope="{ option, remove }"
                            >
                              <span class="custom__tag">
                                <span
                                  >{{ option.customer_name }}</span
                                >
                                <span
                                  class="custom__remove"
                                  @click="remove(option)"
                                  >❌</span
                                >
                              </span>
                            </template>
                            <template slot="clear" slot-scope="props">
                              <div
                                class="multiselect__clear"
                                v-if="coupon_customer.length"
                                @mousedown.prevent.stop="clearAll(props.search)"
                              ></div>
                            </template>
                            <span slot="noResult"
                              >{{
                                trans.get(
                                  "__JSON__.Oops! No elements found. Consider changing the search query"
                                )
                              }}.</span
                            >
                          </multiselect>
                          <div
                            v-if="$v.typeform.coupon_customer.$error"
                            class="invalid-feedback"
                          >
                            <span v-if="!$v.typeform.coupon_customer.required"
                              >{{
                                trans.get(
                                  "__JSON__.Please choose at least one customer"
                                )
                              }}.</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Customer Section End -->

          <!-- SubCategories Section Start -->
          <div class="card" v-if="this.coupon_applied_type != 1">
            <div class="card-body">
              <h4 class="card-title">
                {{ trans.trans("__JSON__.Sub Categories") }}
              </h4>
              <p class="card-title-desc"></p>
              <div class="row">
                <div class="col-md-12">
                  <div class="vendor-main">
                    <!-- <div class="col-sm-3 col-12">
                      <div class="form-group">
                        <label class="required">{{
                          trans.trans("__JSON__.Category")
                        }}</label>
                        <select
                          class="custom-select"
                          v-model="$v.typeform.category_id.$model"
                          id="category_id"
                          name="category_id"
                          @change="getSubCategory($event)"
                          :class="{
                            'is-invalid': $v.typeform.category_id.$error,
                          }"
                        >
                          <option value="">
                            {{ trans.get("__JSON__.Select Category") }}
                          </option>
                          <option
                            v-for="cat in categories"
                            :value="cat.category_id"
                            :key="cat.category_id"
                          >
                            {{ cat.category_name }}
                          </option>
                        </select>
                        <div
                          v-if="$v.typeform.category_id.$error"
                          class="invalid-feedback"
                        >
                          <span v-if="!$v.typeform.category_id.required">{{
                            trans.get("__JSON__.Please select category")
                          }}</span>
                        </div>
                      </div>
                    </div> -->

                    <div class="col-sm-3 col-12">
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          v-on:click="Onclick()"
                          v-model="typeform.get_sub_category"
                          class="custom-control-input"
                          id="all_rest"
                          true-value="1"
                          false-value="0"
                        />
                        <label class="custom-control-label" for="all_rest">{{
                          trans.trans(
                            "__JSON__.Promo code valid for all SubCategories"
                          )
                        }}</label>
                      </div>
                    </div>
                    <div class="col-sm-1 col-12 m-coupon-or">
                      <p>{{ trans.get("__JSON__.OR") }}</p>
                    </div>
                    <div class="col-sm-8 col-12">
                      <div class="search-box mr-2 d-inline-block">
                        <div class="position-relative">
                          <multiselect
                            v-model="$v.typeform.coupon_sub_category.$model"
                            id="ajax"
                            v-bind:disabled="typeform.get_sub_category != 0"
                            label="menu_name"
                            track-by="menu_name"
                            :placeholder="
                              trans.trans('__JSON__.Sub Category Search')
                            "
                            open-direction="bottom"
                            :options="searchCategories"
                            :multiple="true"
                            :searchable="true"
                            :loading="isLoading"
                            :internal-search="true"
                            :clear-on-select="true"
                            :close-on-select="false"
                            :max-height="600"
                            :show-no-results="false"
                            :hide-selected="true"
                            @search-change="asyncSubCategory"
                            :class="{
                              'is-invalid':
                                $v.typeform.coupon_sub_category.$error,
                            }"
                          >
                            <template
                              slot="tag"
                              slot-scope="{ option, remove }"
                            >
                              <span class="custom__tag">
                                <span>{{ option.menu_name }}</span>
                                <span
                                  class="custom__remove"
                                  @click="remove(option)"
                                  >❌</span
                                >
                              </span>
                            </template>
                            <template slot="clear" slot-scope="props">
                              <div
                                class="multiselect__clear"
                                v-if="coupon_sub_category.length"
                                @mousedown.prevent.stop="clearAll(props.search)"
                              ></div>
                            </template>
                            <span slot="noResult"
                              >{{
                                trans.get(
                                  "__JSON__.Oops! No elements found. Consider changing the search query"
                                )
                              }}.</span
                            >
                          </multiselect>
                          <div
                            v-if="$v.typeform.coupon_sub_category.$error"
                            class="invalid-feedback"
                          >
                            <span
                              v-if="!$v.typeform.coupon_sub_category.required"
                              >{{
                                trans.get(
                                  "__JSON__.Please choose at least one sub category"
                                )
                              }}.</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <button class="btn btn-primary mr-1 mt-3">
                    {{ trans.get("__JSON__.Update Promo Code") }}
                  </button>
                  <b-button
                    @click="$router.go(-1)"
                    type="button"
                    variant="secondary"
                    class="mt-3"
                    >{{ trans.get("__JSON__.Cancel") }}</b-button
                  >
                </div>
              </div>
            </div>
          </div>
          <!-- SubCategories Section End -->

          <!-- Products Section Start -->
          <div class="card" v-if="this.coupon_applied_type != 0">
            <div class="card-body">
              <h4 class="card-title">{{ trans.trans("__JSON__.Products") }}</h4>
              <p class="card-title-desc"></p>
              <div class="row">
                <div class="col-md-12">
                  <div class="vendor-main">
                    <div class="col-sm-3 col-12">
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          v-on:click="productOnclick()"
                          v-model="typeform.get_product"
                          class="custom-control-input"
                          id="all_rest"
                          true-value="1"
                          false-value="0"
                        />
                        <label class="custom-control-label" for="all_rest">{{
                          trans.trans(
                            "__JSON__.Promo code valid for all SubCategories"
                          )
                        }}</label>
                      </div>
                    </div>
                    <div class="col-sm-1 col-12 m-coupon-or">
                      <p>{{ trans.get("__JSON__.OR") }}</p>
                    </div>
                    <div class="col-sm-8 col-12">
                      <div class="search-box mr-2 d-inline-block">
                        <div class="position-relative">
                          <multiselect
                            v-model="$v.typeform.coupon_product.$model"
                            id="ajax"
                            v-bind:disabled="typeform.get_product != 0"
                            label="item_name"
                            track-by="item_name"
                            :placeholder="
                              trans.trans('__JSON__.Product Search')
                            "
                            open-direction="bottom"
                            :options="products"
                            :multiple="true"
                            :searchable="true"
                            :loading="isLoading"
                            :internal-search="true"
                            :clear-on-select="true"
                            :close-on-select="false"
                            :max-height="600"
                            :show-no-results="false"
                            :hide-selected="true"
                            @search-change="asyncProduct"
                            :class="{
                              'is-invalid': $v.typeform.coupon_product.$error,
                            }"
                          >
                            <template
                              slot="tag"
                              slot-scope="{ option, remove }"
                            >
                              <span class="custom__tag">
                                <span>{{ option.item_name }}</span>
                                <span
                                  class="custom__remove"
                                  @click="remove(option)"
                                  >❌</span
                                >
                              </span>
                            </template>
                            <template slot="clear" slot-scope="props">
                              <div
                                class="multiselect__clear"
                                v-if="coupon_product.length"
                                @mousedown.prevent.stop="clearAll(props.search)"
                              ></div>
                            </template>
                            <span slot="noResult"
                              >{{
                                trans.get(
                                  "__JSON__.Oops! No elements found. Consider changing the search query"
                                )
                              }}.</span
                            >
                          </multiselect>
                          <div
                            v-if="$v.typeform.coupon_product.$error"
                            class="invalid-feedback"
                          >
                            <span v-if="!$v.typeform.coupon_product.required"
                              >{{
                                trans.get(
                                  "__JSON__.Please choose at least one product"
                                )
                              }}.</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <button class="btn btn-primary mr-1 mt-3">
                    {{ trans.get("__JSON__.Update Promo Code") }}
                  </button>
                  <!-- <b-button
                    @click="$router.go(-1)"
                    type="button"
                    variant="secondary"
                    class="mt-3"
                    >{{ trans.get("__JSON__.Cancel") }}</b-button
                  > -->
                  <router-link
                    :to="{name:'coupon-list'}"
                  >
                    <b-button
                      type="button"
                      variant="secondary"
                      class="mt-3"
                      >{{ trans.get("__JSON__.Cancel") }}</b-button
                    >
                  </router-link>  
                </div>
              </div>
            </div>
          </div>
          <!-- Products Section End -->

          <!-- location Section Start -->
          <!-- <div class="card" v-if="country_count > 1 || state_count > 1 || city_count > 1"> 
            <div class="card-body">
              <h4 class="card-title">{{ trans.get('__JSON__.Select Location') }}</h4>
              <p class="card-title-desc"></p>
              <div class="col-md-12">
                <div class="row">
                  <div v-if="country_count > 1" class="col-sm-4">
                    <div class="form-group">
                      <label class="control-label">{{ trans.get('__JSON__.Country') }}</label>
                      <select
                        class="custom-select"
                        v-model="$v.typeform.country.$model"
                        @change="getVendorState"
                        id="country"
                        name="country"
                        :class="{ 'is-invalid': $v.typeform.country.$error }"
                      >
                        <option value selected>{{ trans.get('__JSON__.Select Country') }}</option>
                        <option
                          v-for="con in countries"
                          :value="con.id"
                          :key="con.id"
                        >{{con.country_name}}</option>
                      </select>
                      <div v-if="$v.typeform.country.$error" class="invalid-feedback">
                        <span
                          v-if="!$v.typeform.country.required"
                        >{{ trans.get('__JSON__.Please select country') }}</span>
                      </div>
                    </div>
                  </div>

                  <div v-if="(country_count == 1 && state_count > 1) || country_count > 1" class="col-sm-4">
                    <div class="form-group">
                      <label class="control-label">{{ trans.get('__JSON__.State') }}</label>
                      <select
                        class="custom-select"
                        v-model="$v.typeform.state.$model"
                        @change="getVendorCity"
                        id="state"
                        name="state"
                        :class="{ 'is-invalid': $v.typeform.state.$error }"
                      >
                        <option value selected>{{ trans.get('__JSON__.Select State') }}</option>
                        <option
                          v-for="sat in states"
                          :value="sat.id"
                          :key="sat.id"
                        >{{sat.state_name}}</option>
                      </select>
                      <div v-if="$v.typeform.state.$error" class="invalid-feedback">
                        <span
                          v-if="!$v.typeform.state.required"
                        >{{ trans.get('__JSON__.Please select state')}}</span>
                      </div>
                    </div>
                  </div>

                  <div v-if="(country_count == 1 && state_count == 1 && city_count > 1) || country_count > 1 || state_count > 1" class="col-sm-4">
                    <div class="form-group">
                      <label class="control-label">{{ trans.get('__JSON__.City') }}</label>
                      <select
                        class="custom-select"
                        v-model="$v.typeform.city.$model"
                        id="city"
                        name="city"
                        :class="{ 'is-invalid': $v.typeform.city.$error }"
                      >
                        <option value selected>{{ trans.get('__JSON__.Select City') }}</option>
                        <option
                          v-for="cit in cities"
                          :value="cit.cityid"
                          :key="cit.cityid"
                        >{{cit.cityname}}</option>
                      </select>
                      <div v-if="$v.typeform.city.$error" class="invalid-feedback">
                        <span
                          v-if="!$v.typeform.city.required"
                        >{{ trans.get('__JSON__.Please select city') }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <button
                class="btn btn-primary mr-1 mt-3"
              >{{ trans.get('__JSON__.Update Promo Code') }}</button>
              <b-button @click="$router.go(-1)" type="button" variant="secondary" class="mt-3">{{ trans.get('__JSON__.Cancel') }}</b-button>
            </div>
          </div> -->
          <!-- location Section End -->
        </form>
      </div>
    </div>
    <!-- end row -->
  </div>
</template>